import ManageVehiclesModal from "./ManageVehiclesModal"

export default  ManageVehiclesModal;



// WEBPACK FOOTER //
// ./src/components/App/Geofence/GeofenceDetail/GeofenceForm/ManageVehiclesModal/index.js